// extracted by css-extract-rspack-plugin
export default {"CardWrapper":"BadgeCard_CardWrapper__Mh0Tn","BadgeImage":"BadgeCard_BadgeImage__j1Qd5","CountBadge":"BadgeCard_CountBadge__CJbQb","StepsList":"BadgeCard_StepsList__BavH3"};